import React, { useState, useEffect } from 'react';
import '../styles/gallery.css';

import pic2 from "../gallery/gallery (100).webp";
import pic3 from "../gallery/gallery (101).webp";
import pic4 from "../gallery/gallery (103).webp";
import pic5 from "../gallery/gallery (104).webp";
import pic6 from "../gallery/gallery (99).webp";
import pic7 from "../gallery/gallery (98).webp";
import pic9 from "../gallery/gallery (96).webp";
import pic10 from "../gallery/gallery (95).webp";
import pic11 from "../gallery/gallery (94).webp";
import pic12 from "../gallery/gallery (93).webp";
import pic13 from "../gallery/gallery (92).webp";
import pic15 from "../gallery/gallery (75).webp";
import pic16 from "../gallery/gallery (90).webp";
import pic17 from "../gallery/gallery (89).webp";
import pic18 from "../gallery/gallery (88).webp";
import pic19 from "../gallery/gallery (87).webp";
import pic20 from "../gallery/gallery (86).webp";
import pic21 from "../gallery/gallery (85).webp";
import pic22 from "../gallery/gallery (84).webp";
import pic25 from "../gallery/gallery (81).webp";
import pic26 from "../gallery/gallery (80).webp";
import pic27 from "../gallery/gallery (79).webp";
import pic28 from "../gallery/gallery (78).webp";
import pic29 from "../gallery/gallery (77).webp";
import pic30 from "../gallery/gallery (76).webp";
import pic31 from "../gallery/gallery (74).webp";
import pic32 from "../gallery/gallery (73).webp";
import pic33 from "../gallery/gallery (72).webp";
import pic34 from "../gallery/gallery (71).webp";
import pic35 from "../gallery/gallery (70).webp";
import pic36 from "../gallery/gallery (69).webp";
import pic38 from "../gallery/gallery (67).webp";
import pic41 from "../gallery/gallery (64).webp";
import pic42 from "../gallery/gallery (63).webp";
import pic43 from "../gallery/gallery (62).webp";
import pic44 from "../gallery/gallery (61).webp";
import pic45 from "../gallery/gallery (60).webp";
import pic47 from "../gallery/gallery (58).webp";
import pic48 from "../gallery/gallery (57).webp";
import pic49 from "../gallery/gallery (56).webp";
import pic50 from "../gallery/gallery (55).webp";
import pic51 from "../gallery/gallery (54).webp";
import pic52 from "../gallery/gallery (53).webp";
import pic53 from "../gallery/gallery (52).webp";
import pic54 from "../gallery/gallery (51).webp";
import pic55 from "../gallery/gallery (50).webp";

const Gallery = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // All 55 gallery items
  const galleryItems = [
    { id: 3, category: 'all', title: 'Forest Path', image: pic3 },
    { id: 35, category: 'all', title: 'Energy', image: pic35 },
    { id: 2, category: 'Events', title: 'Modern Building', image: pic2 },
    { id: 4, category: 'Events', title: 'City Lights', image: pic4 },

    { id: 5, category: 'Events', title: 'Glass Tower', image: pic5 },
    { id: 7, category: 'Events', title: 'Street View', image: pic7 },
    { id: 9, category: 'Events', title: 'Desert Dunes', image: pic9 },
    { id: 10, category: 'Events', title: 'Mountain Peak', image: pic10 },

    { id: 13, category: 'Events', title: 'Landscape', image: pic13 },
    { id: 17, category: 'Events', title: 'Experience', image: pic17 },
    { id: 32, category: 'Events', title: 'Space', image: pic32 },
    { id: 33, category: 'Events', title: 'Time', image: pic33 },

    { id: 34, category: 'Events', title: 'Motion', image: pic34 },
    { id: 25, category: 'all', title: 'Light', image: pic25 },
    { id: 26, category: 'all', title: 'Shadow', image: pic26 },
    { id: 27, category: 'all', title: 'Color', image: pic27 },

    { id: 28, category: 'all', title: 'Texture', image: pic28 },
    { id: 29, category: 'all', title: 'Pattern', image: pic29 },    
    { id: 36, category: 'all', title: 'Power', image: pic36 },
    { id: 38, category: 'all', title: 'Force', image: pic38 },

    { id: 21, category: 'all', title: 'Wonder', image: pic21 },
    { id: 22, category: 'all', title: 'Magic', image: pic22 },
    { id: 30, category: 'all', title: 'Form', image: pic30 },

    { id: 31, category: 'all', title: 'Shape', image: pic31 },
    { id: 19, category: 'all', title: 'Discovery', image: pic19 },
    { id: 20, category: 'all', title: 'Beauty', image: pic20 },
    { id: 15, category: 'all', title: 'Adventure', image: pic15 },

    { id: 16, category: 'all', title: 'Journey', image: pic16 },
    { id: 6, category: 'all', title: 'Ocean Sunset', image: pic6 },
    { id: 45, category: 'Sports', title: 'Reaction', image: pic45 },
    { id: 47, category: 'Sports', title: 'Action', image: pic47 },

    { id: 12, category: 'all', title: 'Sunset', image: pic12 }, 
    { id: 49, category: 'Sports', title: 'Flow', image: pic49 },
    { id: 50, category: 'Sports', title: 'Stream', image: pic50 },
    { id: 51, category: 'Sports', title: 'Current', image: pic51 },

    { id: 52, category: 'Sports', title: 'Tide', image: pic52 },
    { id: 11, category: 'Sports', title: 'Valley View', image: pic11 },
    { id: 53, category: 'Sports', title: 'Wave', image: pic53 },
    { id: 54, category: 'Sports', title: 'Breeze', image: pic54 },

    { id: 55, category: 'Sports', title: 'Wind', image: pic55 },
    { id: 18, category: 'Sports', title: 'Explore', image: pic18 },
    { id: 48, category: 'Sports', title: 'Movement', image: pic48 },   
    { id: 41, category: 'Sports', title: 'Effect', image: pic41 },

    { id: 42, category: 'Sports', title: 'Result', image: pic42 },
    { id: 43, category: 'Sports', title: 'Outcome', image: pic43 },
    { id: 44, category: 'Sports', title: 'Consequence', image: pic44 },
  ];

  const categories = ['all', 'Sports', 'Events'];

  const filteredItems = activeCategory === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeCategory);

  const openLightbox = (item) => {
    setSelectedImage(item);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    const currentIndex = filteredItems.findIndex(item => item.id === selectedImage.id);
    const newIndex = (currentIndex + direction + filteredItems.length) % filteredItems.length;
    setSelectedImage(filteredItems[newIndex]);
  };

  return (
    <>
      {/* Hero Banner */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Gallery</h1>
          </div>
        </div>
      </section>

      <div className="gallery-container">
        <header className="gallery-header">
          <h1 className="gallery-title">Our Gallery</h1>
          <p className="gallery-subtitle">Explore our stunning collection </p>
        </header>

        <div className="filter-section">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        <div className="gallery-grid">
          {filteredItems.map(item => (
            <div 
              key={item.id} 
              className="gallery-item"
              onClick={() => openLightbox(item)}
            >
              <img 
                src={item.image} 
                alt={item.title}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closeLightbox}>×</button>
              <button className="nav-btn prev-btn" onClick={(e) => { e.stopPropagation(); navigateImage(-1); }}>‹</button>
              <img src={selectedImage.image} alt={selectedImage.title} loading="eager" />
              <button className="nav-btn next-btn" onClick={(e) => { e.stopPropagation(); navigateImage(1); }}>›</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Gallery;